import { IconButton, Tooltip } from '@mui/material'
import { ComponentType } from 'react'

type Props = {
  label: string
  Icon: ComponentType
  onClick: () => void
  tabIndex?: 0 | -1
  dataTestId?: string
}

export const CellActionButton = ({ label, Icon, onClick, tabIndex, dataTestId }: Props) => (
  <Tooltip title={label}>
    <IconButton
      variant="contained"
      size="small"
      tabIndex={tabIndex}
      aria-label={label}
      {...(dataTestId ? { ['data-testid']: dataTestId } : {})}
      onClick={(event) => {
        // Rows are often links themselves; the action replaces the row's click rather than adding to it.
        event.preventDefault()
        event.stopPropagation()
        onClick()
      }}
    >
      <Icon />
    </IconButton>
  </Tooltip>
)
